import { render, staticRenderFns } from "./inviteAccountModal.vue?vue&type=template&id=667c2fe9&"
import script from "./inviteAccountModal.vue?vue&type=script&lang=js&"
export * from "./inviteAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./inviteAccountModal.vue?vue&type=style&index=0&id=667c2fe9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports